var playerDiv = document.getElementById('playerDiv');
var videoEl = document.getElementsByClassName('h5live-playerDiv');
videoEl.ontouchmove = function(event) {
	event.preventDefault();
}
var blocktouchEl = document.getElementById('blocktouch-playerDiv');
blocktouchEl.ontouchmove = function(event) {
	event.preventDefault();
}
blocktouchEl.ontouchstart = function(event) {
	event.preventDefault();
}
var soundOffEl = document.getElementsByClassName("soundoff");
soundOffEl.ontouchmove = function(event) {
	event.preventDefault();
}
var soundOnEl = document.getElementsByClassName("soundon");
soundOnEl.ontouchmove = function(event) {
	event.preventDefault();
}
function soundOn() {
	player.unmute();
}
function soundOff() {
	player.mute();
}
function setSoundOnEl() {
	soundOffEl[0].style.display = "none";
	soundOnEl[0].style.display = "block";
}
function setSoundOffEl() {
	soundOffEl[0].style.display = "block";
	soundOnEl[0].style.display = "none";
}
function hideSoundEl() {
	soundOffEl[0].style.display = "none";
	soundOnEl[0].style.display = "none";
}